import { DocumentMetadata } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getExecutiveSummaryDocumentMetadata: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<DocumentMetadata | undefined> = (fetchContext, nominationId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/nominations/${nominationId}/executive-summary-file-metadata`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<DocumentMetadata | undefined>(fetchContext.errorStore, response, 'get executive summary document metadata', true, [404]));
